import { useState } from 'react';
import { useRoleAssignments } from '../hooks/useRoleAssignments';
import { AssignUsersModal } from './AssignUsersModal';
import '../../admin.css';

export interface RoleUserAssignmentsPanelProps {
  roleId: string;
}

export function RoleUserAssignmentsPanel({ roleId }: RoleUserAssignmentsPanelProps) {
  const { data, unassign, refetch } = useRoleAssignments(roleId);
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <section className="role-user-assignments">
      <h3 style={{ marginBottom: 12 }}>Assigned Users</h3>
      <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 12px' }}>
        {data.map((u) => (
          <li
            key={u.id}
            style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '6px 0', borderBottom: '1px solid var(--color-border, #2a2a2a)' }}
          >
            <span style={{ fontWeight: 500 }}>{u.name}</span>
            <span style={{ color: 'var(--color-text-muted, #6b7280)', fontSize: '0.875rem' }}>{u.email}</span>
            <button
              type="button"
              aria-label={`Remove ${u.name}`}
              onClick={() => unassign(roleId, u.id)}
              style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', fontSize: '1.1rem', lineHeight: 1 }}
            >
              ×
            </button>
          </li>
        ))}
      </ul>
      <button type="button" className="rb-btn" onClick={() => setModalOpen(true)}>
        + Assign users
      </button>
      {modalOpen && (
        <AssignUsersModal
          roleId={roleId}
          onClose={() => setModalOpen(false)}
          onAssigned={() => {
            setModalOpen(false);
            refetch();
          }}
        />
      )}
    </section>
  );
}
